<template>
    <component :is="selectedModuleComponent"
               v-bind="props" />
</template>

<script setup>
import { computed } from 'vue'
import StartPageAModule from './StartPageAModule.vue'
import StartPageBModule from './StartPageBModule.vue'
import StartPageCModule from './StartPageCModule.vue'
import StartPageDModule from './StartPageDModule.vue'
import StartPageEModule from './StartPageEModule.vue'
import StartPageFModule from './StartPageFModule.vue'
import StartPageGModule from './StartPageGModule.vue'
import StartPageXModule from './StartPageXModule.vue'

const props = defineProps({
    systemName: String,
    currentModule: String,
    systemData: Object,
});

const moduleComponentMap = {
    a: StartPageAModule,
    b: StartPageBModule,
    c: StartPageCModule,
    d: StartPageDModule,
    e: StartPageEModule,
    f: StartPageFModule,
    g: StartPageGModule,
}

const selectedModuleComponent = computed(() => {
    return moduleComponentMap[props.currentModule] || StartPageXModule
})

</script>

<style scoped></style>
